import { z } from 'zod';
import { kePhoneSchema } from './common.schemas';
import { defineListQuery, listFilter } from './list-query.schemas';

export const EMPLOYMENT_STATUSES = ['active', 'suspended', 'left'] as const;
export type EmploymentStatus = (typeof EMPLOYMENT_STATUSES)[number];

/** `POST /drivers` and `PATCH /drivers/:id` — employment status changes go through their own `POST /drivers/:id/status`. */
export const createDriverSchema = z.object({
  name: z.string().trim().min(1).max(160),
  phone: kePhoneSchema,
  nationalId: z.string().trim().min(1).max(40),
  dateOfBirth: z.iso.date(),
  licenceNumber: z.string().trim().min(1).max(40),
  licenceClasses: z.array(z.string().trim().min(1).max(10)).min(1),
  hazmatCertified: z.boolean(),
});
export type CreateDriverInput = z.infer<typeof createDriverSchema>;

export const updateDriverSchema = createDriverSchema;
export type UpdateDriverInput = z.infer<typeof updateDriverSchema>;

/** `POST /drivers/:id/status` — one endpoint for every transition; nothing restricts which are legal. */
export const driverStatusChangeSchema = z.object({
  status: z.enum(EMPLOYMENT_STATUSES),
  effectiveAt: z.iso.date(),
  reason: z.string().trim().min(1).max(500).optional(),
});
export type DriverStatusChangeInput = z.infer<typeof driverStatusChangeSchema>;

/** `GET /drivers` — search matches name, phone and licence number, not `nationalId` (CLAUDE.md → Data protection). */
export const driverListQuerySchema = defineListQuery({
  sortFields: ['name', 'createdAt'],
  defaultSort: { sort: 'name', order: 'asc' },
  filters: {
    status: listFilter(z.enum(EMPLOYMENT_STATUSES)),
  },
});
export type DriverListQuery = z.infer<typeof driverListQuerySchema>;
